module.exports = __webpack_public_path__ + "static/media/Land-Measuring-Units-in-India.bcb84e69.pdf";